import ApplicationView from './ApplicationView';
import { ResourceContainer } from 'ohzi-core';
import { CSSAnimator } from 'ohzi-core';
import { SceneManager } from 'ohzi-core';
import { CameraManager } from 'ohzi-core';
import { EasingFunctions } from 'ohzi-core';
import { Primitives } from 'ohzi-core';

import { Box3, MeshBasicMaterial, Vector2, Vector3 } from 'three';
import { Text2D } from 'ohzi-core';
import { Math as TMath } from 'three';

class CompanyView extends ApplicationView
{
  constructor()
  {
    super();

    this.z_position = 160;
    this.showing_info = false;
  }

  start(z_position)
  {
    super.start('company', document.querySelector('.company'));

    this.z_position = z_position + 10;

    this.button = document.querySelector('.company__button');

    this.ohzi_text = new Text2D('OHZI', '150px Montserrat Black', '#ffffff', new Vector2(-1, 0));

    this.ohzi_text.position.set(15, 20, this.z_position);
    this.ohzi_text.scale.set(3, 3, 3);

    this.ohzi_text.rotation.y = Math.PI;
    SceneManager.current.add(this.ohzi_text);

    this.interactive_text = new Text2D('INTERACTIVE', '150px Montserrat Black', '#ffffff', new Vector2(-1, 0));

    this.interactive_text.position.set(15, 17.8, this.z_position);
    this.interactive_text.scale.set(3, 3, 3);

    this.interactive_text.rotation.y = Math.PI;
    SceneManager.current.add(this.interactive_text);

    // Debug.draw_cube(new Vector3(0, 20, -50));

    let mat = new MeshBasicMaterial({ map: ResourceContainer.get_resource('ohzi_logo_texture') });
    mat.transparent = true;
    this.ohzi_logo = new Primitives.VerticalPlane(12, 12, '#ffffff', mat); //, mat

    this.ohzi_logo.position.set(-10, 20, this.z_position);
    this.ohzi_logo.geometry.rotateY(Math.PI);
    // ohzi_logo.scale.set(5, 5, 5);

    SceneManager.current.add(this.ohzi_logo);

    this.opacity_animator = new CSSAnimator({
      element: this.container,
      css_property: 'opacity',
      duration: 0.3,
      finished_callback: this.on_opacity_animator_finished.bind(this)
    });
  }

  show_info()
  {
    if (!this.showing_info)
    {
      this.opacity_animator.from = 0;
      this.opacity_animator.to = 1;
      this.opacity_animator.animate();

      this.container.classList.remove('hidden');
      this.showing_info = true;
    }
  }

  hide_info()
  {
    if (this.showing_info)
    {
      this.opacity_animator.from = 1;
      this.opacity_animator.to = 0;
      this.opacity_animator.animate();
      this.showing_info = false;
    }
  }

  on_opacity_animator_finished(animator)
  {
    if (Number(animator.element.style.opacity) === 0)
    {
      animator.element.classList.add('hidden');
    }
  }

  update()
  {
    let t = (Math.abs(CameraManager.current.position.z - this.ohzi_logo.position.z + 20)) / 30;
    t = 1 - TMath.clamp(t, 0, 1);
    t = EasingFunctions.ease_in_out_quint(t);

    this.ohzi_text.opacity = t;
    this.interactive_text.opacity = t;
    this.ohzi_logo.material.opacity = t;

    let z = CameraManager.current.position.z - this.z_position + 20;
    if (z > -40)
    {
      this.button.style.transform = `perspective(200px) translate3d(0,0,${(z) * 4}px)`;
    }

    if (t > 0.8)
    {
      this.show_info();
    }
    else
    {
      this.hide_info();
    }

    this.opacity_animator.update();
  }
}

export default new CompanyView();
